var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenFolder = function SvgOpenFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 20 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    d: "m1 13.358 3.575-4.32a.2.2 0 0 0 .027-.053.245.245 0 0 1 .236-.17h9.923M1 13.359h13.748a.03.03 0 0 0 .021-.008l4.256-4.237a.1.1 0 0 0 .029-.062.24.24 0 0 0-.246-.235H14.76M1 13.358V3.593c0-.13.11-.235.246-.235h6.272q.08 0 .143.044l1.004.685a.25.25 0 0 0 .143.044h5.707a.24.24 0 0 1 .245.235v4.45M7.027 10.929h6"
  })));
};
export default SvgOpenFolder;